import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './TestimoniosData.css'
import baseURL from '../../url';
import NewTestimonio from '../NewTestimonio/NewTestimonio';

export default function TestimoniosData() {
    const [testimonios, setTestimonios] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoNombre, setNuevoNombre] = useState('');
    const [nuevoTestimonio, setNuevoTestimonio] = useState('');
    const [testimonio, setTestimonio] = useState({});
    const [modalImagenVisible, setModalImagenVisible] = useState(false);
    const [imagenSeleccionada, setImagenSeleccionada] = useState('');
    const [filtroId, setFiltroId] = useState('');
    const [filtroNombre, setFiltroNombre] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [fotoPreview, setFotoPreview] = useState(null);
    const [nuevaFoto, setNuevaFoto] = useState(null);
    const [selectedSection, setSelectedSection] = useState('texto');

    const cerrarModalImagen = () => {
        setModalImagenVisible(false);
    };

    const abrirModalImagenSeleccionada = (imagen) => {
        setImagenSeleccionada(imagen);
        setModalImagenVisible(true);
    };

    useEffect(() => {
        cargarTestimonios();
    }, []);

    useEffect(() => {
        setNuevoNombre(testimonio.nombre);
        setNuevoTestimonio(testimonio.testimonio);
    }, [testimonio]);

    const cargarTestimonios = () => {
        fetch(`${baseURL}/testimoniosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTestimonios(data.testimonios || []);
            })
            .catch(error => console.error('Error al cargar testimonios:', error));
    };

    const eliminarTestimonio = (idTestimonio) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#D83098',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/testimonioDelete.php?idTestimonio=${idTestimonio}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarTestimonios();
                    })
                    .catch(error => {
                        console.error('Error al eliminar el testimonio:', error);
                        toast.error(error);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setTestimonio(item);
        setNuevoNombre(item.nombre);
        setNuevoTestimonio(item.testimonio);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const testimoniosFiltrados = testimonios.filter(item => {
        const idMatch = item.idTestimonio.toString().includes(filtroId);
        const nombreMatch = !filtroNombre || item.nombre.toLowerCase().includes(filtroNombre.toLowerCase());
        return idMatch && nombreMatch;
    });

    const recargarTestimonios = () => {
        cargarTestimonios();
    };

    const invertirOrden = () => {
        setTestimonios([...testimonios].reverse());
        setOrdenInvertido(!ordenInvertido);
    };

    const handleUpdateText = (idTestimonio) => {
        const payload = {
            nuevoNombre: nuevoNombre !== '' ? nuevoNombre : testimonio.nombre,
            nuevoTestimonio: nuevoTestimonio !== '' ? nuevoTestimonio : testimonio.testimonio,
        };

        fetch(`${baseURL}/testimonioPut.php?idTestimonio=${idTestimonio}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {
                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    cargarTestimonios();
                    cerrarModal()
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };

    const handleFileChange = (event, setFile, setPreview) => {
        const file = event.target.files[0];
        if (file) {
            const previewURL = URL.createObjectURL(file);
            setFile(file);
            setPreview(previewURL);
        }
    };

    const handleEditarImagen = (idTestimonio) => {
        const formData = new FormData();
        formData.append('idTestimonio', idTestimonio);

        if (nuevaFoto) {
            formData.append('foto', nuevaFoto);
        }

        fetch(`${baseURL}/testimonioImagePut.php`, {
            method: 'POST',
            body: formData
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('La solicitud no fue exitosa');
                }
                return response.json();
            })
            .then(data => {
                if (data.error) {
                    toast.error(data.error);
                } else {
                    toast.success(data.mensaje);
                    window.location.reload();
                }
            })
            .catch(error => {
                console.log(error)
                toast.error(error.message);
            });
    };

    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    return (
        <div>
            <ToastContainer />
            <div className='deFlexContent'>
                <div className='deFlex2'>
                    <NewTestimonio />
                </div>
                <div className='gastosFiltros'>
                    <input type="number" value={filtroId} onChange={(e) => setFiltroId(e.target.value)} placeholder='Id Testimonio' className='filtroInput' />
                    <input type="text" value={filtroNombre} onChange={(e) => setFiltroNombre(e.target.value)} placeholder='Nombre' className='filtroInput' />
                    
                    
                </div>
            </div>

            {modalImagenVisible && (
                <div className="modalImg">
                    <div className="modal-contentImg">
                        <span className="close2" onClick={cerrarModalImagen}>
                            &times;
                        </span>
                        <img src={imagenSeleccionada} alt="Imagen Seleccionada" />
                    </div>
                </div>
            )}

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Editar Texto
                                </button>
                                <button
                                    className={selectedSection === 'imagen' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('imagen')}
                                >
                                    Editar Imagen
                                </button>
                            </div>
                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input
                                        type="text"
                                        value={nuevoNombre !== '' ? nuevoNombre : testimonio.nombre}
                                        onChange={(e) => setNuevoNombre(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset id='descripcion'>
                                    <legend>Testimonio</legend>
                                    <textarea
                                        type="text"
                                        value={nuevoTestimonio}
                                        onChange={(e) => setNuevoTestimonio(e.target.value)}
                                    />
                                </fieldset>
                            </div>
                            <button className='btnPost' onClick={() => handleUpdateText(testimonio.idTestimonio)} >Guardar </button>
                        </div>

                        <div className='sectionImg' style={{ display: selectedSection === 'imagen' ? 'flex' : 'none' }}>
                            <div className='previevProduct'>
                                {fotoPreview ? (
                                    <img src={fotoPreview} alt="Vista previa de la imagen" onClick={() => abrirModalImagenSeleccionada(testimonio.foto)} />
                                ) : (
                                    <>
                                        {testimonio.foto ? (
                                            <img src={testimonio.foto} alt="imagen" onClick={() => abrirModalImagenSeleccionada(testimonio.foto)} />
                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen
                                            </span>
                                        )}
                                    </>
                                )}
                            </div>
                            <fieldset>
                                <legend>Editar Foto </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaFoto, setFotoPreview)} />
                            </fieldset>
                            <button className='btnPost' onClick={() => handleEditarImagen(testimonio.idTestimonio)}>Guardar </button>
                        </div>
                    </div>
                </div>
            )}
            
            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Testimonio</th>
                            <th>Foto</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {testimoniosFiltrados.map(item => (
                            <tr key={item.idTestimonio}>
                                <td>{item.idTestimonio}</td>
                                <td>{item.nombre}</td>
                                <td style={{ maxWidth: '300px', wordWrap: 'break-word' }}>{item.testimonio}</td>
                                <td>
                                    {item.foto ? (
                                        <img src={item.foto} alt="foto" style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '50%' }} />
                                    ) : (
                                        <span className='imgNonetd'>
                                            Sin imagen
                                        </span>
                                    )}
                                </td>
                                <td>
                                    <button className='editar' onClick={() => abrirModal(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <button className='eliminar' onClick={() => eliminarTestimonio(item.idTestimonio)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};


